import api from "./client";

export const getComments = (params = {}) => {
  return api.get("/api/comments/", {
    params,
  });
};

export const createComment = (data) => {
  return api.post("/api/comments/", data);
};
